import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c8da5ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "com_form_contet_admin"
}
const _hoisted_2 = { class: "errorform" }
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}
const _hoisted_4 = {
  key: 1,
  class: "com_form_contet_admin"
}
const _hoisted_5 = { class: "com_sec1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inner1" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "title_left" }, "エージェントセグメント登録")
], -1))
const _hoisted_7 = {
  key: 0,
  class: "error-message",
  style: {"white-space":"pre-wrap"}
}
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "table table-bordered" }
const _hoisted_10 = { class: "thead-light" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col_selection" }, "削除", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col_syozokuAgCnt" }, "所属AG数", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col_lastUploadDate" }, "最終取込日", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col_uploadFileName" }, "アップロードファイル名", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col_uploadDataCnt" }, "取込件数", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col_btnDownload" }, "DL", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col_btnUpload" }, "UPL", -1))
const _hoisted_18 = {
  class: "col_selection",
  "data-name": "mSelection"
}
const _hoisted_19 = ["onUpdate:modelValue"]
const _hoisted_20 = {
  class: "col_agSegmentId",
  "data-name": "mAgSegmentId"
}
const _hoisted_21 = ["onUpdate:modelValue", "onBlur"]
const _hoisted_22 = {
  class: "col_syozokuAgCnt",
  "data-name": "mSyozokuAgCnt",
  style: {"text-align":"right","padding-right":"8px"}
}
const _hoisted_23 = {
  class: "col_lastUploadDate",
  "data-name": "mLastUploadDate"
}
const _hoisted_24 = {
  class: "col_uploadFileName",
  "data-name": "mUploadFileName",
  style: {"text-align":"left","padding-left":"8px"}
}
const _hoisted_25 = {
  class: "col_uploadDataCnt",
  "data-name": "mUploadDataCnt",
  style: {"text-align":"right","padding-right":"8px"}
}
const _hoisted_26 = {
  class: "col_btnDownload",
  "data-name": "mBtnDownload"
}
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["src"]
const _hoisted_29 = {
  class: "col_btnUpload",
  "data-name": "mBtnUpload"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["src"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = { class: "form-inline flex-container" }
const _hoisted_34 = { class: "form-group" }
const _hoisted_35 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_MessageModal = _resolveComponent("MessageModal")!
  const _component_content_pagination = _resolveComponent("content-pagination")!
  const _component_AgSegmentModal = _resolveComponent("AgSegmentModal")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!
  const _component_BackToTop = _resolveComponent("BackToTop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_HeaderComponent, { isAdminPage: true })
    ]),
    (_ctx.isInitError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("section", _hoisted_5, [
            _hoisted_6,
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("input", {
                type: "file",
                ref: "fileInput",
                onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args))),
                style: {"display":"none"},
                accept: ".csv"
              }, null, 544),
              _createElementVNode("table", _hoisted_9, [
                _createElementVNode("thead", _hoisted_10, [
                  _createElementVNode("tr", null, [
                    _hoisted_11,
                    _createElementVNode("th", {
                      class: _normalizeClass([
                  'col_agSegmentId',
                  'sortable',
                  _ctx.isDirectionASC('agSegmentId') ? 'asc' : 'desc',
                ]),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSortItem('agSegmentId')))
                    }, " セグメントID ", 2),
                    _createElementVNode("th", {
                      class: _normalizeClass([
                  'col_agSegmentName',
                  'sortable',
                  _ctx.isDirectionASC('agSegmentName') ? 'asc' : 'desc',
                ]),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSortItem('agSegmentName')))
                    }, " セグメント名 ", 2),
                    _hoisted_12,
                    _hoisted_13,
                    _hoisted_14,
                    _hoisted_15,
                    _hoisted_16,
                    _hoisted_17
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedData, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.agSegmentId,
                      class: _normalizeClass({ changed: item.isChangeAgSegmentName })
                    }, [
                      _createElementVNode("td", _hoisted_18, [
                        _withDirectives(_createElementVNode("input", {
                          id: "mSelection",
                          "onUpdate:modelValue": ($event: any) => ((item.selection) = $event),
                          type: "checkbox",
                          class: "form-check-input"
                        }, null, 8, _hoisted_19), [
                          [_vModelCheckbox, item.selection]
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_20, _toDisplayString(item.agSegmentId), 1),
                      _createElementVNode("td", {
                        class: _normalizeClass(["col_agSegmentName", 
                  item.isChangeAgSegmentName ? 'changed' : 'unchanged'
                ]),
                        "data-name": "mAgSegmentName"
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          style: {"border":"powderblue solid 1px","text-align":"left","padding-left":"8px"},
                          class: _normalizeClass(["txt_agSegmentName form-control", 
                    item.isChangeAgSegmentName ? 'changed' : 'unchanged'
                  ]),
                          id: "mAgSegmentId",
                          "onUpdate:modelValue": ($event: any) => ((item.agSegmentName) = $event),
                          type: "text",
                          maxlength: "255",
                          onBlur: ($event: any) => (_ctx.onBlurAgSegmentName(item))
                        }, null, 42, _hoisted_21), [
                          [_vModelText, item.agSegmentName]
                        ])
                      ], 2),
                      _createElementVNode("td", _hoisted_22, _toDisplayString(item.syozokuAgCnt), 1),
                      _createElementVNode("td", _hoisted_23, _toDisplayString(item.lastUploadDate), 1),
                      _createElementVNode("td", _hoisted_24, _toDisplayString(item.uploadFileName), 1),
                      _createElementVNode("td", _hoisted_25, _toDisplayString(item.uploadDataCnt), 1),
                      _createElementVNode("td", _hoisted_26, [
                        _createElementVNode("button", {
                          type: "button",
                          name: "mBtnDownload",
                          class: "btn btn-sm",
                          onClick: ($event: any) => (_ctx.onDownload(item.agSegmentId))
                        }, [
                          _createElementVNode("img", {
                            src: _ctx.imageDownLoad,
                            alt: "↓"
                          }, null, 8, _hoisted_28)
                        ], 8, _hoisted_27)
                      ]),
                      _createElementVNode("td", _hoisted_29, [
                        _createElementVNode("button", {
                          type: "button",
                          name: "mBtnUpload",
                          class: "btn btn-sm",
                          onClick: ($event: any) => (_ctx.onUpload(item.agSegmentId))
                        }, [
                          _createElementVNode("img", {
                            src: _ctx.imageUpload,
                            alt: "↑"
                          }, null, 8, _hoisted_31)
                        ], 8, _hoisted_30),
                        _createVNode(_component_MessageModal, {
                          isOpen: _ctx.isOpenMessageModal,
                          message: _ctx.modalMessage,
                          onResponse: _ctx.handleMessageResponse
                        }, null, 8, ["isOpen", "message", "onResponse"])
                      ])
                    ], 2))
                  }), 128))
                ])
              ]),
              _createVNode(_component_content_pagination, {
                "current-page": _ctx.currentPage,
                "total-pages": _ctx.totalPages,
                "items-per-page": _ctx.itemsPerPage,
                onPageChanged: _ctx.handlePageChange
              }, null, 8, ["current-page", "total-pages", "items-per-page", "onPageChanged"]),
              _hoisted_32,
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("button", {
                    type: "button",
                    name: "btnDelete",
                    class: "btn btn-footer btn-primary",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onDelete && _ctx.onDelete(...args)))
                  }, " 削除 ")
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("button", {
                    type: "button",
                    name: "btnBack",
                    class: "btn btn-footer btn-primary",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onBack && _ctx.onBack(...args)))
                  }, " 戻る "),
                  _createElementVNode("button", {
                    type: "button",
                    name: "btnClear",
                    class: "btn btn-footer btn-primary",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onClear && _ctx.onClear(...args)))
                  }, " クリア "),
                  _createElementVNode("button", {
                    type: "button",
                    name: "btnUpdate",
                    class: "btn btn-footer btn-primary",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onUpdate && _ctx.onUpdate(...args)))
                  }, " 更新 "),
                  _createElementVNode("button", {
                    type: "button",
                    name: "btnAdd",
                    class: "btn btn-footer btn-primary",
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onNewRegister && _ctx.onNewRegister(...args)))
                  }, " 新規登録 "),
                  _createVNode(_component_AgSegmentModal, {
                    isOpen: _ctx.isOpenAgSegmentModal,
                    agCode: _ctx.agCode,
                    userId: _ctx.userId,
                    categoryId: _ctx.categoryId,
                    onClosed: _ctx.handleAgSegmentModalClosed,
                    onRegistered: _ctx.handleAgSegmentModalRegistered
                  }, null, 8, ["isOpen", "agCode", "userId", "categoryId", "onClosed", "onRegistered"])
                ])
              ])
            ])
          ])
        ])),
    _createElementVNode("div", null, [
      _createVNode(_component_FooterComponent)
    ]),
    _createVNode(_component_BackToTop)
  ], 64))
}